<template>
  <div id="WarehouseLog" class="bg-color1" style="height:calc(100vh);">
    <div ref="app_head" class="col-12 fixed-t">
      <div class="col-12 lh40 bg-color-white pl5 pr5 bb1">
        <div class="col-3 f18" @click="$router.back(-1)"><i class="iconfont icon-31fanhui1 color-primary"></i></div>
        <div class="col-6 t-c color-primary"><span class="f24 fw">A</span><img src="" alt="" srcset="">lmacén</div>
        <div class="col-3 t-r f22 pr3"></div>
      </div>
      <div class="col-12 bg-color-white pl10 pr10 pt9 pb7">
        <div class="col-4">
          <img v-bind:src="product.pic" v-if="product.pic" class="w10 h10">
          <img src="@/assets/goods.jpg" v-else class="w10">
        </div>
        <div class="col-8">
          <div class="col-12 f12 color-muted lh24">{{ product.product_code }}</div>
          <div class="col-12 f14 fw uppercase pb2 el1">{{ product.product_name }}</div>
          <div class="col-12">
            <span class="f16 fw color-black">{{ Math.floor(product.qty / product.package ) }}</span> Bulto  + <span class="f16 fw color-black">{{ product.qty % product.package }}</span> u
          </div>
          <div class="col-12">
            Total Ventas: <span class="f16 fw color-primary">{{ fun.formatMoney(product.total_sales,2,'.',',',true) }}</span> u
          </div>
        </div>
      </div>
      <div class="col-12 bg-color1 pt5 pb5 pl10 pr10 f12 uppercase">
        <div class="col-4 t-c pt8 pb8 r10 b-s-1" :class="{'bg-color-primary color-white':log_type == 'motion','color-muted':log_type != 'motion'}" @click="typeCh('motion')">
          Movimiento
        </div>
        <div class="col-4 t-c pt8 pb8 r10 b-s-1" :class="{'bg-color-primary color-white':log_type == 'day','color-muted':log_type != 'day'}" @click="typeCh('day')">
          Diarias
        </div>
        <div class="col-4 t-c pt8 pb8 r10 b-s-1" :class="{'bg-color-primary color-white':log_type == 'mouth','color-muted':log_type != 'mouth'}" @click="typeCh('mouth')">
          Mensuales
        </div>
      </div>
      <div class="col-12 bg-color-white fw lh32 pl5 pr10 f14 bb1" v-if="log_type=='motion'">
        <div class="col-1 t-c fw">
          -
        </div>
        <div class="col-7 el1 pl5">Tipo de Registro</div>
        <div class="col-2 t-r">Can.</div>
        <div class="col-2 t-r">Actual</div>
      </div>
      <div class="col-12 bg-color-white fw lh32 pl5 pr10 f14 bb1" v-else>
        <div class="col-8">Fecha</div>
        <div class="col-4 t-r">Cant.</div>
      </div>
    </div>
    <div class="h23"></div>
    <div class="col-12 pt5 bg-color1" style="overflow-y: auto;" v-if="log_type=='motion'">
      <div class="col-12 pl8 pr8 bg-color-white pt5 pb5 bb1" v-for="(log, log_i) in data_list" v-bind:key="log_i">
        <div class="col-12">
          <div class="col-1 lh40">
            <i class="iconfont icon-jian color-danger" v-if="log.qty < 0"></i>
            <i class="iconfont icon-jia color-success" v-else></i>
          </div>
          <div class="col-7">
            <div class="col-12 color-muted f12"> {{ log.update_time }} </div>
            <div class="col-12 f14 lh24 uppercase"> {{ log.log_type_name }} </div>
          </div>
          <div class="col-2 t-r lh40 color-muted">
            {{fun.formatMoney(log.qty,2,'.',',',true) }}
          </div>
          <div class="col-2 t-r lh40 color-muted">
            {{fun.formatMoney(log.stock_now,2,'.',',',true) }}
          </div>
        </div>  
      </div>
    </div>
    <div class="col-12 pt5 bg-color1" style="overflow-y: auto;" v-else-if="log_type=='day'">
      <div class="col-12 pl8 pr8 bg-color-white pt5 pb5 bb1" v-for="(day, day_i) in day_list" v-bind:key="day_i" >
        <div class="col-12 lh40">
          <div class="col-8">
            <div class="col-12 color-muted f14">{{ day.date }} </div>
          </div>
          <div class="col-4 t-r color-muted">
            {{fun.formatMoney(day.qty,2,'.',',',true) }}
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 pt5 bg-color1" style="overflow-y: auto;" v-else-if="log_type=='mouth'">
      <div class="col-12 pl8 pr8 bg-color-white pt5 pb5 bb1" v-for="(day, day_i) in day_list" v-bind:key="day_i" >
        <div class="col-12 lh40">
          <div class="col-8">
            <div class="col-12 color-muted f14">{{ day.date }} </div>
          </div>
          <div class="col-4 t-r color-muted">
            {{fun.formatMoney(day.qty,2,'.',',',true) }}
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 t-c pt10 pb10" v-if="pageConfigTotal.total > 20 && log_type=='motion'">
      <page-component :page-config="pageConfigTotal" @changeCurrentPage="changePage"></page-component>
    </div>
  </div>
</template>
<script>
import pageComponent from "../pageComponent"
export default {
  name: 'WarehouseLog',
  data () {
    return {
      product: {},
      product_id: this.$route.query.product_id,
      data_list: [],
      data_page: 1,
      pageConfigTotal:{total:0,pageSize:20,pageNo:1},
      log_type: 'motion',
      day_list:[]
    }
  },
  created: function () {
    this.get_list_data();
  },
  methods: {
    get_list_data() {
      let post_data = {};
      post_data.product_id = this.product_id;
      post_data.page = this.pageConfigTotal.pageNo - 1;
      this.post(this.api_url + 'manage/warehouse_log', post_data).then((res)=>{
        if(res.status == 1){
          this.data_list = res.data.warehouse_log;
          this.product = res.data.product;
          this.pageConfigTotal.total = res.data['warehouse_log_count'];
          if(!this.product.total_sales){
            this.product.total_sales = 0;
          }
        }else{
          this.data_list = []
        }
      })
    },
    get_list_sales(){
      let post_data = {};
      post_data.product_id = this.product_id;
      post_data.type = this.log_type;
      this.post(this.api_url + 'manage/product_sales', post_data).then((res)=>{
        if(res.status == 1){
          this.day_list = res.data.sales;
        }else{
          this.data_list = []
        }
      })
    },
    changePage(page){
      this.pageConfigTotal.pageNo = page
      this.$store.commit('setAppArgs',{product_page: page});
      this.get_list_data();
    },
    typeCh(type){
      this.log_type = type;
      if(this.log_type == 'motion'){
        this.get_list_data();
      }else{
        this.get_list_sales();
      }
    },
    go_cate(){
      this.$router.push({name:'M_ProductCateList'});
    },
    del_page_args(){
      this.$store.commit('setAppArgs',{cate_id: '', cate_name: ''});
      this.get_list_data();
    },
    go_product(id){
      this.$router.push({name:'M_Product',query:{from:this.$route.name, id: id}});
    },
    clearKeyword(){
      this.keyword = '';
      this.$store.commit('setAppArgs',{product_keyword: ''});
      this.get_list_data();
    }
  },
  components:{'page-component':pageComponent}
}
</script>



// WEBPACK FOOTER //
// src/components/Main/WarehouseLog.vue